import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { convertV3CalendarEventToAppointmentDetails } from '../../views/CalendarV3/helpers';

type ListCalendarEventsByAttendeePageParams = {
  cursor: string;
  limit: number;
};

export const useGetCalendarEventsByAttendeeId = (
  attendeeId: string,
  locationId: string,
  pageParam?: ListCalendarEventsByAttendeePageParams
) => {
  const { isScheduleV3FlagEnabled } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  const { locationTimezoneMap } = SchedulerV3.Helpers.useScheduleLocationTimezoneShallowStore('locationTimezoneMap');

  const ListCalendarEventsByAttendee = SchedulerV3.Queries.useListCalendarEventsByAttendeeQuery({
    request: {
      attendeeId,
      locationId,
      limit: pageParam?.limit,
      cursor: pageParam?.cursor,
    },
    options: {
      enabled: isScheduleV3FlagEnabled && !!locationId && !!attendeeId,
      select: (data) => {
        return {
          ...data,
          pages: data.pages.map((page) => ({
            nextCursor: page.nextCursor,
            rows: convertV3CalendarEventToAppointmentDetails(page.events, locationTimezoneMap),
          })),
        };
      },
    },
  });

  const isLoading = ListCalendarEventsByAttendee.isFetching;

  const refetch = ListCalendarEventsByAttendee.refetch;

  return { data: ListCalendarEventsByAttendee, isLoading, refetch };
};
